<template>
  <v-dialog :model-value="isDialogActived" max-width="980px" persistent scrollable>
    <v-card class="dialog-card">
      <v-card-title class="dialog-title">
        <span>{{ getDialogTitle() }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" validate-on="lazy">
          <section class="form-section">
            <h2>Identificacion</h2>
            <v-row dense>
              <v-col cols="12" md="7">
                <v-autocomplete
                  v-if="useExistingName"
                  label="Nombre"
                  v-model="editedItem.name"
                  no-data-text="No hay nombres cargados."
                  :items="getAgrochemicalNamesList"
                  :rules="[rules.requiredFieldRule]"
                  clearable
                  v-bind="fieldProps"
                />
                <v-text-field
                  v-else
                  label="Nombre"
                  v-model="editedItem.name"
                  :rules="[rules.requiredFieldRule]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="1" class="d-flex align-center">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <v-btn
                      v-bind="props"
                      :icon="useExistingName ? 'add_circle_outline' : 'filter_list'"
                      variant="text"
                      color="primary"
                      @click="toggleNameMode"
                    />
                  </template>
                  <span>{{ useExistingName ? 'Cargar un nombre nuevo' : 'Elegir nombre existente' }}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  label="Tipo"
                  v-model="editedItem.agrochemicalType"
                  item-title="name"
                  return-object
                  :items="getAgrochemicalTypes"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Stock y fechas</h2>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Cantidad"
                  v-model="editedItem.amount"
                  :readonly="!canChangeAmount"
                  type="number"
                  min="0"
                  :rules="[rules.requiredFieldRule, rules.min0]"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  label="Unidad de Medida"
                  v-model="editedItem.measurementUnit"
                  item-value="id"
                  item-title="name"
                  :items="getMeasurmentUnits"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Precio unitario"
                  v-model="editedItem.price"
                  type="number"
                  step="1"
                  min="0"
                  prefix="$"
                  suffix="dolar"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Fecha de Compra"
                  v-model="editedItem.purchaseDate"
                  type="date"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Fecha de Vencimiento"
                  v-model="editedItem.expirationDate"
                  type="date"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>

          <section class="form-section">
            <h2>Producto</h2>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Principio Activo"
                  v-model="editedItem.activePrincipie"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Concentracion de Principio Activo"
                  v-model="editedItem.principeActiveConcentration"
                  type="number"
                  step="0.1"
                  min="0"
                  suffix="%"
                  v-bind="fieldProps"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Factura" v-model="editedItem.bill" v-bind="fieldProps" />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Laboratorio" v-model="editedItem.laboratory" v-bind="fieldProps" />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Lote de fabricacion" v-model="editedItem.batchCode" v-bind="fieldProps" />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Observaciones"
                  v-model="editedItem.nota"
                  auto-grow
                  rows="3"
                  v-bind="fieldProps"
                />
              </v-col>
            </v-row>
          </section>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="text" @click="close">Cancelar</v-btn>
        <v-btn v-if="canSave" color="primary" @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AddEditAgrochemicalForm',
  computed: {
    ...mapGetters('agrochemicalModule', ['isDialogActived', 'getAgrochemicalNamesList']),
    ...mapGetters('typesModule', ['getAgrochemicalTypes', 'getMeasurmentUnits']),
    ...mapGetters('authModule', ['hasPermission']),
    canSave () { return this.hasPermission(this.editedItem.id > 0 ? 'agrochemicals.products.update' : 'agrochemicals.products.create') },
    canChangeAmount () { return this.hasPermission(this.editedItem.id > 0 ? 'agrochemicals.stock.adjust' : 'agrochemicals.stock.add') }
  },
  created () {
    this.$store.dispatch('typesModule/getAgrochemicalTypes')
    this.$store.dispatch('agrochemicalModule/getAgrochemicalNamesList')
  },

  watch: {
    'isDialogActived': function (val) {
      if (val) {
        this.editedItem = Object.assign({}, this.$store.getters['agrochemicalModule/getSelectedItem'])
        this.useExistingName = false
      }
    }
  },

  methods: {
    getDialogTitle () {
      let dialogTitle
      if (this.editedItem.id > 0) {
        dialogTitle = `Editando Agroquimico: ${this.editedItem.name}`
      } else {
        dialogTitle = 'Agregar Agroquimico'
      }
      return dialogTitle
    },

    toggleNameMode () {
      this.useExistingName = !this.useExistingName
      if (this.useExistingName) {
        this.$store.dispatch('agrochemicalModule/getAgrochemicalNamesList')
      }
    },

    close () {
      this.editedItem = Object.assign({}, this.$store.getters['agrochemicalModule/getDefaultItem'])
      this.$store.dispatch('agrochemicalModule/setSelectedItem', this.editedItem)
      this.valid = true
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.useExistingName = false
      this.$store.dispatch('agrochemicalModule/setDialogActived', false)
    },

    async save () {
      if (!this.canSave) return
      const validation = await this.$refs.form.validate()
      if (validation.valid) {
        try {
          await this.$store.dispatch('agrochemicalModule/saveAgrochemical', this.editedItem)
          this.close()
        } catch (e) {
          console.log('Error saving agrochemical.', e)
        }
      }
    }
  },
  data: () => ({
    useExistingName: false,
    valid: true,
    fieldProps: {
      variant: 'outlined',
      density: 'comfortable'
    },
    rules: {
      requiredFieldRule: v => !!v || 'Campo requerido.',
      min0: v => (v > 0) || 'Debe ingresar un valor mayor que 0'
    },
    editedItem: {
      id: -1,
      name: '',
      nota: '',
      amount: null,
      measurementUnit: null,
      expirationDate: null,
      purchaseDate: null,
      activePrincipie: '',
      principeActiveConcentration: null,
      price: null,
      laboratory: '',
      bill: '',
      batchCode: null,
      agrochemicalType: null
    }
  })
}
</script>
